export const signup = () => {
  window.fbq("track", "signup");
};
export const confirmSignUp = () => {
  window.fbq("track", "confirm");
};
export const subscriptionSuccess = () => {
  window.fbq("track", "success");
};
